<template>
	<div
		class="flex flex-col md:flex-row gap-8 items-center text-center md:text-left"
	>
		<div class="flex flex-col gap-8 md:w-1/2">
			<AtomTitle
				tag="h2"
				size="4xl"
				underline
				class="items-center md:items-start"
			>
				{{ title }}
			</AtomTitle>
			<p class="text-paragraph-size-md">
				{{ description }}
			</p>
			<div class="flex gap-8">
				<AtomButton
					text="Afspraak maken"
					:variant="ButtonVariant.Green"
					icon-left="fa-calendar-days"
					@click="openAppointmentDialog"
				/>
				<AtomButton
					:to="phoneLink"
					:variant="ButtonVariant.Transparent"
					icon-left="fa-phone"
					:text="phoneNumber"
					size="md"
					@click="trackClickToCall('Fysiotherapie_Verzekeraars_bellen', 30)"
				/>
			</div>
		</div>
		<div class="flex items-center justify-center grow h-[26rem]">
			<div
				class="absolute w-80 md:w-96 translate-x-12 h-64 md:h-80 bg-purple-50 -skew-x-12 rotate-45 rounded-full"
			/>
			<div
				v-for="(insurer, index) of insurers"
				v-show="activeImageIndexes.findIndex((i) => i === index) >= 0"
				:key="insurer.logo.src"
				:class="[
					'absolute ',
					activeImageIndexes.findIndex((i) => i === index) === 1
						&& 'translate-y-28 md:translate-y-40 -translate-x-11',
					activeImageIndexes.findIndex((i) => i === index) === 2
						&& '-translate-y-28 md:-translate-y-40 -translate-x-24',
					activeImageIndexes.findIndex((i) => i === index) === 3
						&& '-translate-y-42 -translate-x-36 md:-translate-x-48',
					activeImageIndexes.findIndex((i) => i === index) === 4
						&& '-translate-y-36 translate-x-12',
					activeImageIndexes.findIndex((i) => i === index) === 5
						&& 'translate-y-16 md:translate-y-12 translate-x-36 md:translate-x-48',
					activeImageIndexes.findIndex((i) => i === index) === 6
						&& '-translate-y-16 md:-translate-y-24 translate-x-32 md:translate-x-40',
					activeImageIndexes.findIndex((i) => i === index) === 7
						&& '-translate-y-12 md:-translate-y-16 translate-x-64 md:translate-x-72',
				]"
			>
				<Transition name="bounce">
					<div
						v-show="activeImageIndexes.includes(index)"
						:class="[
							'flex items-center justify-center rounded-full overflow-hidden',
							'border border-purple-100 bg-white shadow-lg',
							activeImageIndexes.findIndex((i) => i === index)
								=== 0 && 'w-36 h-36 lg:w-48 lg:h-48',
							activeImageIndexes.findIndex((i) => i === index)
								=== 1 && 'w-16 h-16 lg:w-24 lg:h-24',
							activeImageIndexes.findIndex((i) => i === index)
								=== 2 && 'w-24 h-24 lg:w-32 lg:h-32',
							activeImageIndexes.findIndex((i) => i === index)
								=== 3 && 'w-24 h-24 lg:w-32 lg:h-32',
							activeImageIndexes.findIndex((i) => i === index)
								=== 4 && 'w-20 h-20 lg:w-30 lg:h-30',
							activeImageIndexes.findIndex((i) => i === index)
								=== 5 && 'w-32 h-32 lg:w-36 lg:h-36',
							activeImageIndexes.findIndex((i) => i === index)
								=== 6 && 'w-24 h-24 lg:w-32 lg:h-32',
							activeImageIndexes.findIndex((i) => i === index)
								=== 7 && 'w-20 h-20 lg:w-30 lg:h-30',
						]"
					>
						<AtomImage
							v-bind="insurer.logo"
							fit="fill"
							img-class="p-4"
						/>
					</div>
				</Transition>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { phoneNumber } from '#base/core/consts/companyData';
import { phoneLink } from '#fysio/core/consts/links';
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import type { InsurerType } from '#base/core/types/InsurerType';

const props = defineProps<{
	title: string;
	description: string;
	insurers: InsurerType[];
}>();

const {
	trackClickToCall,
} = useEventTracking();
const {
	openAppointmentDialog,
} = useDialogs();

const replaceIndex = ref(0);
const activeImageIndexes = reactive([0, 1, 2, 3, 4, 5, 6, 7]);

let interval: NodeJS.Timeout;
if (import.meta.client) {
	interval = setInterval(() => {
		let newImageIndex = Math.floor(Math.random() * props.insurers.length);
		while (activeImageIndexes.includes(newImageIndex)) {
			newImageIndex = Math.floor(Math.random() * props.insurers.length);
		}

		activeImageIndexes.splice(replaceIndex.value, 1, newImageIndex);

		if (replaceIndex.value < 7) {
			replaceIndex.value++;
		}
		else {
			replaceIndex.value = 0;
		}
	}, 1000);
}

onBeforeUnmount(() => {
	clearInterval(interval);
});
</script>
